import { styled } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { OPEN_STATUS } from '../../constants/businessHours';
import moment from 'moment';

const PREFIX = 'ViewBusinessHours';

const classes = {
  container: `${PREFIX}-container`,
  text: `${PREFIX}-text`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },

  [`& .${classes.text}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
    fontSize: '14px',
  },
}));

export const ViewBusinessHours = compose(
  inject('store'),
  observer,
)((props) => {
  const { store } = props;
  const { deliveryStore } = store;
  const businessHours = deliveryStore?.businessHours;

  return (
    <StyledBox className={classes.container}>
      {businessHours &&
        businessHours.map((businessHour, index) => (
          <Box key={`business-hours-${index}`}>
            <Grid container alignItems="center">
              <Grid size={{ xs: 4, sm: 2 }}>
                <Typography className={classes.text}>{businessHour?.day}: </Typography>
              </Grid>
              <Grid size={{ xs: 8, sm: 4 }}>
                <Typography className={classes.text}>
                  {businessHour?.status === OPEN_STATUS
                    ? `${moment(businessHour?.open, ['HH:mm']).format('hh:mm a')} - ${moment(businessHour?.close, ['HH:mm']).format('hh:mm a')}`
                    : 'Closed'}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        ))}
    </StyledBox>
  );
});
